export default "__VITE_ASSET__Di3hrTWJ__"